import React from "react";

const BranchComplianceInfo = ({ formData, updateField, errors }) => {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            GST Number
          </label>
          <input
            type="text"
            value={formData.compliance.gstNumber}
            onChange={(e) =>
              updateField(
                "compliance",
                "gstNumber",
                e.target.value.toUpperCase()
              )
            }
            className={`w-full px-3 py-2 border rounded-lg ${
              errors.gstNumber ? "border-red-500" : "border-gray-300"
            }`}
            placeholder="22AAAAA0000A1Z5"
          />
          {errors.gstNumber && (
            <p className="text-red-500 text-xs mt-1">{errors.gstNumber}</p>
          )}
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            PAN Number
          </label>
          <input
            type="text"
            value={formData.compliance.panNumber}
            onChange={(e) =>
              updateField(
                "compliance",
                "panNumber",
                e.target.value.toUpperCase()
              )
            }
            className="w-full px-3 py-2 border border-gray-300 rounded-lg"
            placeholder="AAAAA0000A"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Trade License
          </label>
          <input
            type="text"
            value={formData.compliance.tradeLicense}
            onChange={(e) =>
              updateField("compliance", "tradeLicense", e.target.value)
            }
            className="w-full px-3 py-2 border border-gray-300 rounded-lg"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Establishment Year
          </label>
          <input
            type="number"
            value={formData.compliance.establishmentYear}
            onChange={(e) =>
              updateField(
                "compliance",
                "establishmentYear",
                parseInt(e.target.value)
              )
            }
            className="w-full px-3 py-2 border border-gray-300 rounded-lg"
            min="1900"
            max={new Date().getFullYear()}
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Hallmarking License
          </label>
          <input
            type="text"
            value={formData.compliance.hallmarkingLicense}
            onChange={(e) =>
              updateField("compliance", "hallmarkingLicense", e.target.value)
            }
            className="w-full px-3 py-2 border border-gray-300 rounded-lg"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            BIS Registration
          </label>
          <input
            type="text"
            value={formData.compliance.bisRegistration}
            onChange={(e) =>
              updateField("compliance", "bisRegistration", e.target.value)
            }
            className="w-full px-3 py-2 border border-gray-300 rounded-lg"
          />
        </div>
      </div>
    </div>
  );
};

export default BranchComplianceInfo;
